import { BillInterface } from '../../models/bill.interface';

export interface BillInterfaceState {
  bill: BillInterface;
}

export const initialBillState: BillInterfaceState = {
  bill: null
};
